<template>
  <v-container>

    <!-- řádek s reload ikonou -->
    <v-row justify="start">
      <v-col cols="12" class="d-flex justify-start">
        <v-btn
          icon
          variant="text"
          color="primary"
          size="60"
          :loading="loading"
          @click="fetchData"
          title="Reload"
        >
          <v-icon size="x-large">mdi-reload</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="rows"
      :loading="loading"
      density="comfortable"
      item-key="id"
      class="elevation-2"
      :items-per-page="100"
      fixed-header
      hover
    >
      <template #item.id="{ item }">
        <span class="text-no-wrap">{{ item.id }}</span>
      </template>

      <template #item.event_race="{ item }">
        <div class="text-no-wrap">
          <strong>{{ item.event_name || '—' }}</strong>
          <span v-if="item.race_name"> — {{ item.race_name }}</span>
        </div>
      </template>

      <template #item.competitor_name="{ item }">
        <div class="text-no-wrap">
          <span v-if="item.competitor_category_name">{{ item.competitor_category_name }}</span> {{ item.competitor_name }}
          
        </div>
      </template>

      <template #item.competitor_start_time="{ item }">
        <span class="text-no-wrap">{{ $formatDateTime(item.competitor_start_time) }}</span>
      </template>
      <template #item.changed_time="{ item }">
        <span class="text-no-wrap">{{ $formatDateTime(item.changed_time) }}</span>
      </template>
      <template #item.recieved="{ item }">
        <span class="text-no-wrap">{{ $formatDateTime(item.recieved) }}</span>
      </template>
    </v-data-table>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import apiClient from '/api.js'
import { useI18n } from 'vue-i18n'
import { useSnackbarStore } from '@/stores/snackbarStore'

const { t } = useI18n()
const snackbar = useSnackbarStore()
const loading = ref(false)
const rows = ref([])

const headers = [
  { title: 'ID', key: 'id', width: 50 },
  { title: 'Závod', key: 'event_race', minWidth: 220 },
  { title: 'Status', key: 'competitor_status', width: 100 },
  { title: 'Závodník', key: 'competitor_name', minWidth: 150 },
  { title: 'Index', key: 'competitor_index' },
  { title: 'Starý čip', key: 'competitor_old_si_number', minWidth: 110, },
  { title: 'Nový čip', key: 'competitor_new_si_number', minWidth: 110 },
  { title: 'Start', key: 'competitor_start_time' },
  { title: 'Změněno', key: 'changed_time' },
  { title: 'Přijato', key: 'recieved' },
  { title: 'Komentář', key: 'comment', minWidth: 260 },
]

const fetchData = async () => {
  loading.value = true
  try {
    const res = await apiClient.get('/ochecklist/')
    rows.value = Array.isArray(res?.data) ? res.data : []
  } catch (e) {
    snackbar.error(t('errors.error'))
    console.error(e)
  } finally {
    loading.value = false
  }
}

onMounted(fetchData)
</script>
